import { KITCHEN_STAFF_ROSTER } from '@/features/kitchen/kitchenStaff'
import { loadJson, saveJson } from '@/features/kitchen/storage/persist'

export const ATTENDANCE_STORAGE_PREFIX = 'superoti.kitchen.attendance.'

export type AttendanceEventRecord = {
  at: string
  timeLabel: string
  photoUrl: string | null
  onTime?: boolean
}

export type StaffDayAttendanceRecord = {
  userId: string
  date: string
  checkIn?: AttendanceEventRecord
  checkOut?: AttendanceEventRecord
}

export function todayDateKey(): string {
  return new Date().toISOString().slice(0, 10)
}

export function loadAttendanceDayRecords(date: string): Record<string, StaffDayAttendanceRecord> {
  return loadJson<Record<string, StaffDayAttendanceRecord>>(`${ATTENDANCE_STORAGE_PREFIX}${date}`) ?? {}
}

export function saveAttendanceDayRecords(
  date: string,
  records: Record<string, StaffDayAttendanceRecord>,
): void {
  saveJson(`${ATTENDANCE_STORAGE_PREFIX}${date}`, records)
}

export function getAttendanceDaySummary(date = todayDateKey()) {
  const records = loadAttendanceDayRecords(date)
  const roster = KITCHEN_STAFF_ROSTER

  let checkedIn = 0
  let finished = 0
  const notCheckedIn: string[] = []
  const onShift: string[] = []

  for (const staff of roster) {
    const record = records[staff.id]
    if (!record?.checkIn) {
      notCheckedIn.push(staff.name)
      continue
    }
    checkedIn += 1
    if (record.checkOut) {
      finished += 1
    } else {
      onShift.push(staff.name)
    }
  }

  return {
    total: roster.length,
    checkedIn,
    finished,
    notCheckedIn,
    onShift,
    notCheckedInCount: notCheckedIn.length,
  }
}
